import { createFileRoute } from '@tanstack/react-router'

import { ConfirmacaoPorClique } from '@/components/gestor/recuperacao/ConfirmacaoPorClique'

function ConfirmarIndicacao() {
  return (
    <ConfirmacaoPorClique
      confirmacao="indicacao-confirmada"
      id="titulo-confirmar-indicacao"
      titulo="Confirmar o e-mail indicado"
      texto="Um administrador indicou este endereço para receber um link de senha. A caixa de login da pessoa tem 24 horas para cancelar; sem cancelamento, o link chega aqui quando o prazo acabar."
      botao="Confirmar e-mail para o link de senha"
      sucesso="E-mail confirmado. O link de senha sai quando o prazo da indicação acabar."
    />
  )
}

/*
 * `/gestor/indicacao/confirmar#t=…`: tela pública aberta pelo link que a caixa
 * indicada recebe. Abrir não confirma nada; o botão confirma.
 */
export const Route = createFileRoute('/gestor/indicacao/confirmar')({
  component: ConfirmarIndicacao,
})
